import createDeepEqualSelector from 'utils/reselect/typescript/createDeepEqualSelector';

import { AppState } from 'services/types';
import { WorksheetEntitySummaryIndex } from 'services/worksheet/types';
import { getWorksheetInnerEntitiesAsString } from 'services/worksheet/utils';
import { selectFertilizerWorksheetEntitySummaries } from '../../../../selectors';
import { OwnProps } from './index';

const selectEntitySummaryIndex = (
    state: AppState,
    props: OwnProps
): WorksheetEntitySummaryIndex => props.entitySummaryIndex;

const selectBlocks = createDeepEqualSelector(
    selectFertilizerWorksheetEntitySummaries,
    selectEntitySummaryIndex,
    (entitySummaries, index) =>
        getWorksheetInnerEntitiesAsString(entitySummaries, index)
);

const makeSelectBlocks = (): typeof selectBlocks => selectBlocks;

export { selectEntitySummaryIndex, makeSelectBlocks };
